<template>
    <div>
        <SalesMaster addNew="/inventory/do/" type="DO"></SalesMaster>
    </div>
</template>
<script>
import { mapState } from "vuex";
import SalesMaster from '@/views/sales/master.vue'

export default {
    components: { SalesMaster },
    computed:{
    ...mapState({
        language_terms: state => state.languages.language_terms,
      }),
    }
}
</script>
